import { defineMessages } from 'react-intl'

export default defineMessages({
    price: {
        defaultMessage: 'Precio',
    },
    checkPrice: {
        defaultMessage: 'Consultar precios',
    },
    onlyViat: {
        defaultMessage: 'Solo disponible con Via-T',
    },
    full: {
        defaultMessage: 'Completo',
    },
    book: {
        defaultMessage: 'Reservar',
    },
    viewDetail: {
        defaultMessage: 'Ver precios',
    },
    services: {
        defaultMessage: 'Servicios',
    },
    distance: {
        defaultMessage: 'A {distance}',
    },
    day: {
        defaultMessage: 'día',
    },
    hourTimeUnit: {
        defaultMessage: 'h',
    },
    hour: {
        defaultMessage: 'hora',
    },
    viewParking: {
        defaultMessage: 'Ver parking',
    },
})
